import React, { useState } from 'react';
import { ReactSession } from "react-client-session";
import MsgUtils from '../Tools/MsgUtils';
import axios from 'axios';
const server = process.env.REACT_APP_SERVER;

function ResponderMensaje(props) {
    const {selectComu, setActualizar, actualizar,setModalResponder}=props;
    const [respuesta, setRespuestas] = useState('');
    const [documento, setDocumento] = useState([]);
    const [adjuntos, setAdjuntos] = useState([]);
    const cargarArchivo = (e) => {
        var archiv = e.target.files[0];
        console.log(archiv);
        setDocumento([...documento, archiv]);
        var id = JSON.parse(localStorage.getItem('info')).ID_EMPLEADO;
        var formData = new FormData()
        formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + '.' + id);
        try {
            axios.post(`http://172.19.51.3:4370`, formData, {
                'Accept': 'application/json',
                'content-type': 'multipart/form-data'
            }).then(res => { setAdjuntos([...adjuntos, res.data]); console.log(res.data) })
                .catch(error => console.log(error.message))
        } catch (error) {
            console.error('Error al subir el archivo !!');
        }
    }
    const responderMensaje=()=> {
        var idUsuario = ReactSession.get('idSession');
        var regional = ReactSession.get('regional');
        var empresaSucursal = ReactSession.get('empresaSucursal');
        var elegido = selectComu.ID_COMUNICADO;
        fetch(`${server}/comunicados/lista/respuestaMensaje`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                vId: 0, idUsuario, regional, mensage:respuesta, empresaSucursal, elegido, tipo:'RES',idAdjunto:adjuntos[0]
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setModalResponder(false);
                    MsgUtils.msgCorrecto("Respuesta enviada ...");
                    setActualizar(actualizar + 1);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    const eliminarDocumento = (e) => {
        console.log(documento.filter(item => item.name !== e.target.id));
        setAdjuntos([]);
        setDocumento(documento.filter(item => item.name !== e.target.id));
    }
    return (
        <div className='container-fluid'>
            <div className="form-floating mb-3 pt-2">
                <textarea className="form-control"
                    placeholder="Leave a comment here"
                    value={respuesta}
                    onChange={(e) => setRespuestas(e.target.value)}
                    style={{ height: "140px" }}>
                </textarea>
                <label for="floatingTextarea2" >RESPUESTA</label>
            </div>
            <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 g-1'>
                    <div className='col col-sm-11'>
                        <div className='container px-4 bg-light'>
                            <span className='text'>Documentos Adjuntos</span>
                            <ul className="list-group bg-secondary">
                                {documento.map((item) => {
                                    return (
                                        <li className="list-group-item position-relative" key={item.size}>
                                            {item.name}
                                            <button className='btn position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'
                                                id={item.name}
                                                onClick={eliminarDocumento}>
                                                X
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className={adjuntos.length === 1 ? 'd-none' : 'col col-sm-1'}>
                        <label className='btn fs-1 text-success'>
                            <i className="fa-solid fa-file-circle-plus"></i>
                            <input type="file" onChange={cargarArchivo} />
                        </label>
                    </div>
                </div>
            </div>
            <button type="button" className="btn btn-secondary bg-gradient w-100" onClick={responderMensaje}>Responder <i className="fa-solid fa-paper-plane"></i></button>
        </div>
    )
}

export default ResponderMensaje
